export enum JobSummary {
  Not_started = 0,
  Slipped = 1,
  In_Progress = 2,
  Complete = 3,
  Failed_Checks = 4
}
